// HowItWorks.js
import React, { useState } from 'react';
import './HowItWorks.css';

const processSteps = [
    {
      id: 'signing-up',
      title: 'Signing Up',
      description: 'Learn how to join One-Time Fantasy and start the fun.',
      content: (
        <div>
          <p>Creating an account with One-Time Fantasy is your first step into a world of niche sports fantasy drafting. Simply provide your name, email address, and physical address to get started. Make sure to verify your email to activate your account.</p>
          <img src="https://placehold.co/400x300?text=Signing+Up" alt="Sign Up Process" />
        </div>
      ),
    },
    {
      id: 'depositing',
      title: 'Depositing',
      description: 'Find out how to deposit funds into your One-Time Fantasy account.',
      content: (
        <div>
          <p>Depositing into your One-Time Fantasy account is seamless. Use Debit/Credit card, PayPal, or Crypto with a minimum deposit of $25. Get ready to enter the contests with no deposit fees for amounts less than $5000.</p>
          <img src="https://placehold.co/400x300?text=Depositing" alt="Depositing Funds" />
        </div>
      ),
    },
    {
      id: 'contest-lobby',
      title: 'Contest Lobby',
      description: 'Navigate the contest lobby to find contests that excite you.',
      content: (
        <div>
          <p>The contest lobby is your gateway to various contests. Filter by Sport, Prize Pool, and more to find your preferred contest. Detailed information about each contest, including entry fees and prize pools, is readily available.</p>
          <img src="https://placehold.co/400x300?text=Contest+Lobby" alt="Contest Lobby" />
        </div>
      ),
    },
    {
      id: 'registering-for-a-contest',
      title: 'Registering for a Contest',
      description: 'Discover how to register for contests and draft your winning team.',
      content: (
        <div>
          <p>Registering for a contest is straightforward. Select a contest from the lobby, and you'll be taken to its page. Here, you can view all necessary contest details, including entrants, competitor prices, and prize pool information, before finalizing your team.</p>
          <img src="https://placehold.co/400x300?text=Registering" alt="Registering for a Contest" />
        </div>
      ),
    },
    {
      id: 'live-scoring',
      title: 'Live Scoring',
      description: 'Experience the excitement of live scoring as the real-life events unfold.',
      content: (
        <div>
          <p>Keep track of your contest standings with live scoring. Updated in real time, the live scoring feature ensures you're always in the loop as your drafted players progress through the real-life event.</p>
          <img src="https://placehold.co/400x300?text=Live+Scoring" alt="Live Scoring" />
        </div>
      ),
    },
    {
      id: 'withdrawing',
      title: 'Withdrawing',
      description: 'Learn how to withdraw your winnings and manage your funds.',
      content: (
        <div>
          <p>Withdrawing your winnings is easy and flexible with One-Time Fantasy. Whether it's a small victory or a big win, you can withdraw your funds through multiple methods, ensuring your prize money is always accessible.</p>
          <img src="https://placehold.co/400x300?text=Withdrawing" alt="Withdrawing Funds" />
        </div>
      ),
    }
  ];

const HowItWorks = () => {
  const [activeStep, setActiveStep] = useState(processSteps[0].id);

  const handleNavigate = (id) => {
    setActiveStep(id);
    const stepElement = document.getElementById(id);
    window.scrollTo({
      top: stepElement.offsetTop - 100,
      behavior: 'smooth',
    });
  };

  return (
    <div className="howitworks-container">
      <nav className="sidebar">
        {processSteps.map((step) => (
          <button
            key={step.id}
            className={`nav-item ${activeStep === step.id ? 'active' : ''}`}
            onClick={() => handleNavigate(step.id)}
          >
            {step.title}
          </button>
        ))}
      </nav>
      <div className="content">
        <h1>How One-Time Fantasy Works</h1>
        {processSteps.map((step) => (
          <div key={step.id} id={step.id} className="section">
            <h2>{step.title}</h2>
            <p>{step.description}</p>
            <div>{step.content}</div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default HowItWorks;
